import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import PinImage from '../../images/pin-blk@3x.png';
import styles from './PinButton.css';

function PinButton({ onClick, isPlacingPin }) {
  return (
    <Button
      className={cx(styles.pinButton, { [styles.placingPin]: isPlacingPin })}
      data-test-id="pin-placement-btn"
      mode="map"
      onClick={onClick}
    >
      <img alt={getMessage('image.pin.button')} src={PinImage} />
    </Button>
  );
}

PinButton.propTypes = {
  isPlacingPin: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PinButton;
